/* Zafira native Shopify interaction recovery. Loaded once after zafira-product-data.liquid. */
(function zafiraRuntime(window, document) {
  'use strict';

  if (window.__zafiraRuntimeInstalled) return;
  window.__zafiraRuntimeInstalled = true;

  var CATALOG = window.ZafiraCatalog || readCatalog();
  var PRODUCT_MAP = CATALOG.products || CATALOG.sourceProducts || {};
  var VARIANT_MAP = CATALOG.variants || CATALOG.sourceVariants || {};
  var HANDLE_MAP = CATALOG.handles || {};
  var MESSAGE_ID = 'zafira-runtime-message';
  var DRAWER_ID = 'zafira-runtime-cart-drawer';
  var sourceHostPattern = /(^|\.)(zafiraorganics\.com|k231jk-dx\.myshopify\.com)$/i;
  var accordionItemSelector = '.pdp-faq-item, .faq-item, .sci-faq__item, .zafira-faq__item, [data-zafira-accordion]';
  var accordionQuestionSelector = '.pdp-faq-q, .faq-q, .sci-faq__question, .zafira-faq__question, [data-accordion-trigger]';
  var accordionAnswerSelector = '.pdp-faq-a, .faq-a, .sci-faq__answer, .zafira-faq__answer, [data-accordion-panel]';
  var purchaseSelector = '.bundle-add-to-cart, .bundle-card-buy, .add-to-cart-button, [data-replo-add-product-variant-to-cart], [data-zafira-add-to-cart], [data-action="add-to-cart"], [data-action="checkout"]';

  window.ZafiraCatalog = CATALOG;

  function readCatalog() {
    var node = document.getElementById('zafira-product-data');
    if (!node) return { products: {}, variants: {}, handles: {} };
    try {
      return JSON.parse(node.textContent || '{}');
    } catch (error) {
      return { products: {}, variants: {}, handles: {}, error: error.message };
    }
  }

  function asString(value) {
    return value === undefined || value === null ? '' : String(value).trim();
  }

  function closest(node, selector) {
    return node && node.nodeType === 1 ? node.closest(selector) : null;
  }

  function sourceIdFromElement(element) {
    if (!element) return '';
    var candidates = [
      element.getAttribute('data-zafira-product-handle'),
      element.getAttribute('data-product-handle'),
      element.getAttribute('data-handle'),
      element.getAttribute('data-product-id'),
      element.getAttribute('data-productid'),
      element.getAttribute('data-variant-id'),
      element.getAttribute('data-variantid'),
      element.getAttribute('data-variant')
    ];
    var form = element.tagName === 'FORM' ? element : closest(element, 'form');
    if (form) {
      var idInput = form.querySelector('input[name="id"], select[name="id"]');
      if (idInput) candidates.push(idInput.value);
    }
    for (var i = 0; i < candidates.length; i += 1) {
      var value = asString(candidates[i]);
      if (value) return value;
    }
    return '';
  }

  function mappingForElement(element) {
    var cursor = element;
    while (cursor && cursor !== document.documentElement) {
      var directHandle = asString(cursor.getAttribute && (cursor.getAttribute('data-zafira-product-handle') || cursor.getAttribute('data-replo-product-handle') || cursor.getAttribute('data-product-handle') || cursor.getAttribute('data-handle')));
      if (directHandle) {
        return { handle: directHandle, product: PRODUCT_MAP[HANDLE_MAP[directHandle]] || null, explicit: true };
      }
      var id = sourceIdFromElement(cursor);
      if (id && VARIANT_MAP[id]) {
        return { handle: VARIANT_MAP[id].handle, product: PRODUCT_MAP[VARIANT_MAP[id].source_product_id] || null, sourceVariant: id, explicit: true };
      }
      if (id && PRODUCT_MAP[id]) return { handle: PRODUCT_MAP[id].handle, product: PRODUCT_MAP[id], sourceProduct: id, explicit: true };
      cursor = cursor.parentElement;
    }
    var match = window.location.pathname.match(/^\/products\/([^/?#]+)/i);
    if (match && HANDLE_MAP[match[1]]) {
      return { handle: match[1], product: PRODUCT_MAP[HANDLE_MAP[match[1]]] || null, explicit: true };
    }
    return null;
  }

  function destinationProduct(context) {
    return context && context.product && context.product.destination && context.product.destination.product || null;
  }

  function sourceProductIsMissing(context) {
    return !!(context && context.explicit && !destinationProduct(context));
  }

  function variantsFor(product) {
    return product && Array.isArray(product.variants) ? product.variants : [];
  }

  function allPlans(context) {
    var destination = context && context.product && context.product.destination;
    var groups = destination && Array.isArray(destination.selling_plan_groups) ? destination.selling_plan_groups : [];
    var plans = [];
    groups.forEach(function (group) {
      (group.selling_plans || []).forEach(function (plan) { plans.push(plan); });
    });
    return plans;
  }

  function destinationVariant(context, form) {
    var product = destinationProduct(context);
    var variants = variantsFor(product);
    if (!variants.length) return null;

    var current = form && form.querySelector('input[name="id"], select[name="id"]');
    var currentValue = current && asString(current.value);
    var existing = variants.find(function (variant) { return asString(variant.id) === currentValue; });
    if (existing) return existing;

    var selected = selectedOptions(form, product);
    var matched = variants.find(function (variant) {
      if (!selected.length) return false;
      return selected.every(function (choice, index) {
        return asString(variant['option' + (index + 1)] || (variant.options || [])[index]).toLowerCase() === choice.toLowerCase();
      });
    });
    if (!matched && context.sourceVariant && VARIANT_MAP[context.sourceVariant].options) {
      var sourceOptions = VARIANT_MAP[context.sourceVariant].options;
      matched = variants.find(function (variant) {
        return sourceOptions.every(function (choice, index) {
          return asString(variant['option' + (index + 1)] || (variant.options || [])[index]) === asString(choice);
        });
      });
    }
    if (matched && matched.available !== false) return matched;
    if (matched) return matched;
    return variants.find(function (variant) { return variant.available !== false; }) || variants[0];
  }

  function selectedOptions(form, product) {
    if (!form || !product || !Array.isArray(product.options)) return [];
    var data = new FormData(form);
    return product.options.map(function (option, index) {
      var optionName = typeof option === 'string' ? option : option.name;
      var names = ['options[' + optionName + ']', optionName, 'option' + (index + 1), 'options[' + (index + 1) + ']'];
      for (var i = 0; i < names.length; i += 1) {
        var value = data.get(names[i]);
        if (value !== null && asString(value)) return asString(value);
      }
      var selectedControl = form.querySelector('[data-option-index="' + (index + 1) + '"][aria-checked="true"], [data-option-position="' + (index + 1) + '"][aria-checked="true"]');
      return selectedControl ? asString(selectedControl.getAttribute('data-value') || selectedControl.textContent) : '';
    }).filter(Boolean);
  }

  function selectedPlan(context, form) {
    var plans = allPlans(context);
    if (!plans.length || !form) return null;
    var control = form.querySelector('[name="selling_plan"]:checked, select[name="selling_plan"], input[name="selling_plan"]');
    if (!control) return null;
    var raw = asString(control.value);
    var validId = plans.find(function (plan) { return asString(plan.id) === raw; });
    if (validId) return validId;

    var name = asString(control.getAttribute('data-selling-plan-name'));
    if (!name && control.tagName === 'OPTION') name = asString(control.textContent);
    if (!name && control.labels && control.labels[0]) name = asString(control.labels[0].textContent);
    if (!name && control.parentElement) name = asString(control.parentElement.textContent);
    return plans.find(function (plan) { return asString(plan.name).toLowerCase() === name.toLowerCase(); }) || null;
  }

  function selectedQuantity(form) {
    if (!form) return 1;
    var field = form.querySelector('[name="quantity"], input[type="number"][data-quantity]');
    var choice = form.querySelector('.bundle-option.selected[data-qty], [data-quantity][aria-checked="true"], input[name="bundle"]:checked');
    var quantity = field ? Number.parseInt(field.value, 10) : choice ? Number.parseInt(choice.getAttribute('data-qty') || choice.getAttribute('data-quantity') || choice.value, 10) : 1;
    return Number.isFinite(quantity) && quantity > 0 ? Math.min(quantity, 9999) : 1;
  }

  function formatMoney(cents) {
    var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active || document.documentElement.getAttribute('data-currency') || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: currency }).format(Number(cents || 0) / 100);
    } catch (error) {
      return '$' + (Number(cents || 0) / 100).toFixed(2);
    }
  }

  function syncProductPresentation(context, form) {
    var variant = destinationVariant(context, form);
    if (!variant || !form) return;
    var scope = form.closest('[data-zafira-product-handle], [data-productid], [data-product-id], .product, .pdp, .pricing, .product-form') || form;
    var selectors = '[data-zafira-product-price], [data-product-price], .pdp-price, .product-price, .price__regular .price-item--regular';
    scope.querySelectorAll(selectors).forEach(function (price) {
      if (/(saving|save |off\b|discount)/i.test(price.className + ' ' + price.getAttribute('data-price-role'))) return;
      price.textContent = formatMoney(variant.price);
      price.setAttribute('data-zafira-destination-price', asString(variant.price));
    });
    var idInput = form.querySelector('input[name="id"], select[name="id"]');
    if (idInput) idInput.value = asString(variant.id);
  }

  function ensureMessage() {
    var message = document.getElementById(MESSAGE_ID);
    if (message) return message;
    message = document.createElement('div');
    message.id = MESSAGE_ID;
    message.setAttribute('role', 'status');
    message.setAttribute('aria-live', 'polite');
    message.setAttribute('aria-atomic', 'true');
    message.style.cssText = 'position:fixed;z-index:2147483646;right:1rem;bottom:1rem;max-width:min(30rem,calc(100vw - 2rem));padding:.8rem 1rem;border-radius:.35rem;background:#161616;color:#fff;font:inherit;box-shadow:0 4px 18px rgba(0,0,0,.24);';
    document.body.appendChild(message);
    return message;
  }

  function message(text, error) {
    var node = ensureMessage();
    node.textContent = text;
    node.style.background = error ? '#8a1f11' : '#161616';
  }

  function disabledPurchase(context, element) {
    var target = element && (element.matches('form') ? element : closest(element, 'form')) || element;
    if (target && target.matches && target.matches('form')) {
      target.querySelectorAll('button[type="submit"], input[type="submit"], ' + purchaseSelector).forEach(function (control) {
        control.disabled = true;
        control.setAttribute('aria-disabled', 'true');
        control.setAttribute('title', 'This product is not available in this store.');
      });
    } else if (target) {
      target.disabled = true;
      target.setAttribute('aria-disabled', 'true');
    }
    if (context) message('This product is not available in this store yet. Purchasing has been disabled.', true);
  }

  function createDrawer() {
    var drawer = document.getElementById(DRAWER_ID);
    if (drawer) return drawer;
    drawer = document.createElement('section');
    drawer.id = DRAWER_ID;
    drawer.hidden = true;
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.setAttribute('aria-labelledby', DRAWER_ID + '-title');
    drawer.style.cssText = 'position:fixed;z-index:2147483647;right:0;top:0;width:min(26rem,100vw);height:100vh;padding:2rem;background:#fff;color:#111;box-shadow:-5px 0 25px rgba(0,0,0,.25);';
    drawer.innerHTML = '<button type="button" data-zafira-close-cart aria-label="Close cart">×</button><h2 id="' + DRAWER_ID + '-title">Added to your cart</h2><p data-zafira-cart-copy>Your item is in the cart.</p><p><a href="/cart" data-zafira-cart-view>View cart</a></p><button type="button" data-zafira-close-cart>Continue shopping</button>';
    document.body.appendChild(drawer);
    return drawer;
  }

  function openAddedDrawer(item) {
    var drawer = createDrawer();
    var copy = drawer.querySelector('[data-zafira-cart-copy]');
    if (copy) copy.textContent = (item && item.product_title ? item.product_title + ' was added to your cart.' : 'Your item was added to the cart.');
    drawer.hidden = false;
    var focus = drawer.querySelector('[data-zafira-cart-view]');
    if (focus) focus.focus();
  }

  function closeDrawer() {
    var drawer = document.getElementById(DRAWER_ID);
    if (drawer) drawer.hidden = true;
  }

  function nativeAdd(context, form, trigger, afterAdd) {
    var offerRoot = closest(form || trigger, '[data-replo-product-container]');
    if (offerRoot && offerRoot.querySelector('[data-zafira-offer-required]') && !window.ZafiraOffersReady) {
      message('Bundle and subscription pricing must be configured and verified in this store before this offer can be purchased.', true);
      return;
    }
    if (sourceProductIsMissing(context)) {
      disabledPurchase(context, form || trigger);
      return;
    }
    var variant = destinationVariant(context, form);
    if (!variant) {
      message('This product has no available destination variant. Purchasing has been disabled.', true);
      disabledPurchase(context, form || trigger);
      return;
    }
    if (variant.available === false) {
      message('The selected variant is sold out.', true);
      return;
    }

    if (window.ZafiraPreview) {
      message('Purchasing is disabled in this local reconstruction preview.', true);
      return;
    }
    var plan = selectedPlan(context, form);
    var planControl = form && form.querySelector('[name="selling_plan"]:checked, select[name="selling_plan"], input[type="hidden"][name="selling_plan"]');
    if (planControl && planControl.value && !plan) {
      message('This subscription option is not configured in the new store yet. Choose a one-time purchase.', true);
      return;
    }
    var quantityRoot = form || closest(trigger, '.zafira-native-embed, [data-zafira-product-handle]');
    var quantityCard = closest(trigger, '[data-qty]');
    var quantity = quantityCard ? Number.parseInt(quantityCard.getAttribute('data-qty'), 10) : selectedQuantity(quantityRoot);
    var body = new URLSearchParams({ id: asString(variant.id), quantity: asString(quantity || 1) });
    if (plan) body.set('selling_plan', asString(plan.id));
    if (trigger) trigger.setAttribute('aria-busy', 'true');

    fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
      credentials: 'same-origin',
      body: body.toString()
    }).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (payload) {
        if (!response.ok) throw new Error(payload.description || payload.message || 'Could not add this item to the cart.');
        return payload;
      });
    }).then(function (item) {
      document.dispatchEvent(new CustomEvent('zafira:cart:added', { detail: { item: item, context: context } }));
      message('Added to cart.');
      if (afterAdd === 'cart') window.location.assign('/cart');
      else openAddedDrawer(item);
    }).catch(function (error) {
      message(error.message || 'Could not add this item to the cart. Please try again.', true);
    }).finally(function () {
      if (trigger) trigger.removeAttribute('aria-busy');
    });
  }

  function isSourceCheckout(url) {
    if (!url) return false;
    try {
      var parsed = new URL(url, window.location.href);
      return sourceHostPattern.test(parsed.hostname) && parsed.hostname !== window.location.hostname && /\/(?:checkouts?|cart)(?:\/|$)/i.test(parsed.pathname);
    } catch (error) {
      return false;
    }
  }

  function legacyCommerceIntent(element) {
    var inline = asString(element.getAttribute && element.getAttribute('onclick'));
    var action = asString(element.getAttribute && (element.getAttribute('data-action') || element.getAttribute('data-zafira-legacy-commerce')));
    var text = (inline + ' ' + action).toLowerCase();
    if (/checkout/.test(text)) return 'checkout';
    if (/add.?to.?cart|cart\/add/.test(text)) return 'add';
    return '';
  }

  function isCartControl(element) {
    return !!closest(element, '[data-cart-toggle], [data-cart-drawer-toggle], [data-cart-button], .header__icon--cart, .cart-icon, [aria-label*="cart" i], a[href="/cart"], a[href^="/cart?"]');
  }

  function isAccountControl(element) {
    return !!closest(element, '[data-account-toggle], [data-account-button], .header__icon--account, [aria-label*="account" i], a[href*="/account"]');
  }

  function initializeAccordion(item, index) {
    if (item.dataset.zafiraAccordionReady) return;
    var trigger = item.querySelector(accordionQuestionSelector) || item.querySelector('button, summary, [role="button"]');
    var panel = item.querySelector(accordionAnswerSelector);
    if (!trigger || !panel) return;
    item.dataset.zafiraAccordionReady = 'true';
    if (!panel.id) panel.id = 'zafira-accordion-panel-' + index;
    if (trigger.tagName !== 'BUTTON' && trigger.tagName !== 'SUMMARY') {
      trigger.setAttribute('role', 'button');
      if (!trigger.hasAttribute('tabindex')) trigger.setAttribute('tabindex', '0');
    }
    trigger.setAttribute('aria-controls', panel.id);
    setAccordion(item, item.classList.contains('open') || item.classList.contains('active') || trigger.getAttribute('aria-expanded') === 'true');
  }

  function setAccordion(item, expanded) {
    var trigger = item.querySelector(accordionQuestionSelector) || item.querySelector('button, summary, [role="button"]');
    var panel = item.querySelector(accordionAnswerSelector);
    if (!trigger || !panel) return;
    item.classList.toggle('open', expanded);
    item.classList.toggle('active', expanded);
    trigger.setAttribute('aria-expanded', String(expanded));
    panel.hidden = !expanded;
  }

  function carouselFor(element) {
    return closest(element, '.reason__carousel, .carousel, [data-zafira-carousel]');
  }

  function changeSlide(carousel, nextIndex) {
    if (!carousel) return;
    var track = carousel.querySelector('.carousel__track, [data-carousel-track]');
    var slides = track ? Array.prototype.slice.call(track.querySelectorAll('.carousel__slide, [data-carousel-slide]')) : [];
    if (!slides.length) return;
    var index = ((nextIndex % slides.length) + slides.length) % slides.length;
    slides.forEach(function (slide, slideIndex) {
      slide.classList.toggle('active', slideIndex === index);
      slide.setAttribute('aria-hidden', String(slideIndex !== index));
    });
    carousel.querySelectorAll('.carousel__dot, [data-carousel-dot]').forEach(function (dot, dotIndex) {
      dot.classList.toggle('active', dotIndex === index);
      dot.setAttribute('aria-current', slideIndexToBoolean(dotIndex === index));
    });
    if (track) track.scrollTo({ left: slides[index].offsetLeft - track.offsetLeft, behavior: 'smooth' });
  }

  function slideIndexToBoolean(value) {
    return value ? 'true' : 'false';
  }

  function activeSlideIndex(carousel) {
    var slides = carousel.querySelectorAll('.carousel__slide, [data-carousel-slide]');
    for (var i = 0; i < slides.length; i += 1) if (slides[i].classList.contains('active')) return i;
    return 0;
  }

  function activateThumbnail(button) {
    var gallery = closest(button, '.pdp-gallery, .media-gallery, [data-zafira-gallery]');
    if (!gallery) return;
    var id = button.getAttribute('aria-controls') || button.getAttribute('data-media-id') || button.getAttribute('data-target');
    if (!id) return;
    gallery.querySelectorAll('.dialog-thumbnails-list__thumbnail, [data-thumbnail], [data-media-id]').forEach(function (thumbnail) {
      thumbnail.classList.toggle('active', thumbnail === button);
      thumbnail.setAttribute('aria-current', thumbnail === button ? 'true' : 'false');
    });
    var target = document.getElementById(id) || gallery.querySelector('[data-media-id="' + cssEscape(id) + '"]');
    if (target && target.scrollIntoView) target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  }

  function cssEscape(value) {
    return window.CSS && window.CSS.escape ? window.CSS.escape(value) : String(value).replace(/[^a-zA-Z0-9_-]/g, '\\$&');
  }

  function resetQuantity(button, direction) {
    var form = closest(button, 'form') || closest(button, '.quantity-selector, [data-quantity-selector]');
    var field = form && form.querySelector('[name="quantity"], input[type="number"]');
    if (!field) return false;
    var value = selectedQuantity(form) + direction;
    var min = Number.parseInt(field.min, 10);
    var max = Number.parseInt(field.max, 10);
    field.value = String(Math.max(Number.isFinite(min) ? min : 1, Math.min(Number.isFinite(max) ? max : 9999, value)));
    field.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  function onSubmit(event) {
    var form = event.target;
    if (!form || form.tagName !== 'FORM') return;
    var context = mappingForElement(form);
    if (!context || !context.explicit) return;
    var isCartForm = /\/cart\/add(?:\.js)?(?:\?|$)/i.test(asString(form.getAttribute('action'))) || !!form.querySelector('input[name="id"], select[name="id"]');
    if (!isCartForm) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    nativeAdd(context, form, null, 'drawer');
  }

  function onClick(event) {
    var target = closest(event.target, 'button, a, input[type="submit"], [role="button"]');
    if (!target) return;

    if (target.matches('[data-zafira-close-cart]')) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    var checkoutHref = target.tagName === 'A' && target.getAttribute('href');
    if (checkoutHref && isSourceCheckout(checkoutHref)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign('/cart');
      return;
    }

    if (isAccountControl(target)) {
      var accountHref = target.tagName === 'A' ? target.getAttribute('href') : '';
      if (!accountHref || /^https?:\/\//i.test(accountHref) && sourceHostPattern.test(new URL(accountHref, window.location.href).hostname)) {
        event.preventDefault();
        window.location.assign('/account');
        return;
      }
    }

    if (isCartControl(target)) {
      var cartHref = target.tagName === 'A' ? target.getAttribute('href') : '';
      if (!cartHref || isSourceCheckout(cartHref) || /^https?:\/\//i.test(cartHref) && sourceHostPattern.test(new URL(cartHref, window.location.href).hostname)) {
        event.preventDefault();
        window.location.assign('/cart');
        return;
      }
    }

    if (target.matches('.quantity-plus, [data-quantity-action="increase"]')) {
      if (resetQuantity(target, 1)) event.preventDefault();
      return;
    }
    if (target.matches('.quantity-minus, [data-quantity-action="decrease"]')) {
      if (resetQuantity(target, -1)) event.preventDefault();
      return;
    }

    var accordion = closest(target, accordionQuestionSelector);
    if (accordion) {
      var accordionItem = closest(accordion, accordionItemSelector);
      if (accordionItem && accordionItem.dataset.zafiraAccordionReady) {
        event.preventDefault();
        setAccordion(accordionItem, accordion.getAttribute('aria-expanded') !== 'true');
        return;
      }
    }

    var carousel = carouselFor(target);
    if (carousel && target.matches('.carousel__btn--prev, [data-carousel-prev], .carousel__btn--next, [data-carousel-next], .carousel__dot, [data-carousel-dot]')) {
      event.preventDefault();
      var index = activeSlideIndex(carousel);
      if (target.matches('.carousel__btn--prev, [data-carousel-prev]')) changeSlide(carousel, index - 1);
      else if (target.matches('.carousel__btn--next, [data-carousel-next]')) changeSlide(carousel, index + 1);
      else changeSlide(carousel, Array.prototype.indexOf.call(carousel.querySelectorAll('.carousel__dot, [data-carousel-dot]'), target));
      return;
    }

    if (target.matches('.dialog-thumbnails-list__thumbnail, [data-thumbnail]')) {
      activateThumbnail(target);
      return;
    }

    var intent = legacyCommerceIntent(target);
    var purchase = target.matches(purchaseSelector) || intent;
    if (!purchase) return;
    if (closest(target, '[data-zafira-legacy-transport="true"]')) return;
    var context = mappingForElement(target);
    if (!context || !context.explicit) return;
    var form = closest(target, 'form');
    event.preventDefault();
    event.stopImmediatePropagation();
    nativeAdd(context, form, target, intent === 'checkout' ? 'cart' : 'drawer');
  }

  function onKeydown(event) {
    if (event.key === 'Escape') closeDrawer();
    var trigger = closest(event.target, accordionQuestionSelector);
    if (trigger && (event.key === 'Enter' || event.key === ' ')) {
      var item = closest(trigger, accordionItemSelector);
      if (item && item.dataset.zafiraAccordionReady) {
        event.preventDefault();
        setAccordion(item, trigger.getAttribute('aria-expanded') !== 'true');
      }
    }
  }

  function neutralizeLegacyCommerce(root) {
    root.querySelectorAll('[onclick]').forEach(function (element) {
      if (closest(element, '[data-zafira-legacy-transport="true"]')) return;
      var intent = legacyCommerceIntent(element);
      if (intent && mappingForElement(element)) {
        element.removeAttribute('onclick');
        element.setAttribute('data-zafira-legacy-commerce', intent);
      }
    });
  }

  function prepare(root) {
    if (!root || root.nodeType !== 1 && root !== document) return;
    var scope = root === document ? document : root;
    scope.querySelectorAll(accordionItemSelector).forEach(function (item, index) { initializeAccordion(item, index); });
    neutralizeLegacyCommerce(scope);
    scope.querySelectorAll('form').forEach(function (form) {
      if (!/\/cart\/add(?:\.js)?(?:\?|$)/i.test(asString(form.getAttribute('action'))) && !form.querySelector('input[name="id"], select[name="id"]')) return;
      var context = mappingForElement(form);
      if (!context || !context.explicit) return;
      if (sourceProductIsMissing(context)) disabledPurchase(context, form);
      else syncProductPresentation(context, form);
    });
  }

  function ready() {
    prepare(document);
    document.addEventListener('submit', onSubmit, true);
    document.addEventListener('click', onClick, true);
    document.addEventListener('keydown', onKeydown, true);
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) prepare(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true });
  else ready();
}(window, document));
